import React from 'react';

export default function Settings({ teamData, advisorToken, advisorPassword, onBack }) {
  return (
    <div style={{ minHeight: '100vh', background: '#f8f7fc' }}>
      <header style={{ background: 'linear-gradient(135deg,#7c3aed,#6366f1)', color: '#fff', padding: '16px 20px', position: 'sticky', top: 0, zIndex: 100 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <div>
            <h1 style={{ fontSize: 20, fontWeight: 900, marginBottom: 2 }}>⚙️ Paramètres Équipe</h1>
            <div style={{ fontSize: 12.5, opacity: 0.9 }}>Gestion des membres, dispatch et file d'attente</div>
          </div>
          <button onClick={onBack} style={{ background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 8, padding: '8px 14px', color: '#fff', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>← Retour</button>
        </div>
      </header>
      <main style={{ padding: 20, maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e2e8f0', padding: 20 }}>
          <h2 style={{ fontSize: 18, fontWeight: 800, color: '#1e1b4b', marginBottom: 20 }}>Paramètres (version de base)</h2>
          <p>Version minimale pour test de build - fonctionnalités complètes à venir</p>
          <div style={{ marginTop: 20, padding: 16, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 8 }}>
            <h3 style={{ fontSize: 14, fontWeight: 700, color: '#166534', marginBottom: 8 }}>Fonctionnalités prévues :</h3>
            <ul style={{ margin: 0, paddingLeft: 20, color: '#166534', fontSize: 13 }}>
              <li>👥 Gestion des membres (ajouter, modifier, supprimer, changer mot de passe)</li>
              <li>🔄 Dispatch auto (round-robin) / manuel</li>
              <li>📋 File d'attente avec assignation manuelle</li>
              <li>⚙️ Paramètres : max RDV simultanés, mode dispatch</li>
            </ul>
          </div>
        </div>
      </main>
    </div>
  );
}
